import { connect } from 'react-redux'
import { withAuthenticatedUser } from '../../../../Permissions'

import { getSimilarContacts } from './findSimilar.actions'
import FindSimilarDialog, { UnstyledFindSimilarDialog } from './Dialog.component'

const mapStateToProps = ({
  media: {
    similarContacts: { similarContacts },
  },
}) => ({
  loading: similarContacts.loading,
  error: similarContacts.error,
  similarContacts: similarContacts.data,
})

const mapDispatchToProps = (
  dispatch,
  {
    contactId,
    authenticatedUser: {
      user: { sessionId },
    },
  },
) => ({
  async onOpen(numContacts = 10) {
    try {
      const similarContactsResults = dispatch(getSimilarContacts(contactId, numContacts, sessionId))
      await similarContactsResults
    } catch (e) {
      // Already handled by reducer
    }
  },
})

export { UnstyledFindSimilarDialog }

export default withAuthenticatedUser(connect(mapStateToProps, mapDispatchToProps)(FindSimilarDialog))
